import type { SVGProps } from 'react'

const I = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props} />
)

export const IconDashboard = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/></I>
)
export const IconChallenge = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/></I>
)
export const IconSportsbook = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><circle cx="12" cy="12" r="9"/><path d="M3 12 h18 M12 3 a14 14 0 0 1 0 18 M12 3 a14 14 0 0 0 0 18"/></I>
)
export const IconBets = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><path d="M4 7 h16 v3 a3 3 0 0 1 -3 3 H7 a3 3 0 0 1 -3 -3 z"/><path d="M9 13 v5 M15 13 v5 M7 21 h10"/></I>
)
export const IconLeaderboard = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><path d="M6 21 V11 M12 21 V5 M18 21 V14"/><path d="M3 21 h18"/></I>
)
export const IconBilling = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><rect x="3" y="6" width="18" height="13" rx="2"/><path d="M3 10 h18 M7 15 h4"/></I>
)
export const IconHelp = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><circle cx="12" cy="12" r="9"/><path d="M9.5 9 a2.5 2.5 0 1 1 3.5 2.3 c-0.7 0.3 -1 0.7 -1 1.7 M12 17 v0"/></I>
)
export const IconSettings = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><circle cx="12" cy="12" r="3"/><path d="M19.4 15 a1.65 1.65 0 0 0 0.33 1.82 l0.06 0.06 a2 2 0 1 1 -2.83 2.83 l-0.06 -0.06 a1.65 1.65 0 0 0 -1.82 -0.33 a1.65 1.65 0 0 0 -1 1.51 V21 a2 2 0 0 1 -4 0 v-0.09 A1.65 1.65 0 0 0 9 19.4 a1.65 1.65 0 0 0 -1.82 0.33 l-0.06 0.06 a2 2 0 1 1 -2.83 -2.83 l0.06 -0.06 a1.65 1.65 0 0 0 0.33 -1.82 a1.65 1.65 0 0 0 -1.51 -1 H3 a2 2 0 0 1 0 -4 h0.09 A1.65 1.65 0 0 0 4.6 9 a1.65 1.65 0 0 0 -0.33 -1.82 l-0.06 -0.06 a2 2 0 1 1 2.83 -2.83 l0.06 0.06 a1.65 1.65 0 0 0 1.82 0.33 H9 a1.65 1.65 0 0 0 1 -1.51 V3 a2 2 0 0 1 4 0 v0.09 a1.65 1.65 0 0 0 1 1.51 a1.65 1.65 0 0 0 1.82 -0.33 l0.06 -0.06 a2 2 0 1 1 2.83 2.83 l-0.06 0.06 a1.65 1.65 0 0 0 -0.33 1.82 V9 a1.65 1.65 0 0 0 1.51 1 H21 a2 2 0 0 1 0 4 h-0.09 a1.65 1.65 0 0 0 -1.51 1 z"/></I>
)
export const IconSun = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><circle cx="12" cy="12" r="4"/><path d="M12 2 v2 M12 20 v2 M4.93 4.93 l1.41 1.41 M17.66 17.66 l1.41 1.41 M2 12 h2 M20 12 h2 M4.93 19.07 l1.41 -1.41 M17.66 6.34 l1.41 -1.41"/></I>
)
export const IconMoon = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><path d="M21 12.8 A9 9 0 1 1 11.2 3 a7 7 0 0 0 9.8 9.8 z"/></I>
)
export const IconBell = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><path d="M6 8 a6 6 0 0 1 12 0 c0 7 3 9 3 9 H3 s3 -2 3 -9"/><path d="M10 21 a2 2 0 0 0 4 0"/></I>
)
export const IconUser = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><circle cx="12" cy="8" r="4"/><path d="M4 21 a8 8 0 0 1 16 0"/></I>
)
export const IconSignOut = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><path d="M9 21 H5 a2 2 0 0 1 -2 -2 V5 a2 2 0 0 1 2 -2 h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></I>
)
export const IconArrowRight = (p: SVGProps<SVGSVGElement>) => (
  <I {...p}><path d="M5 12 h14 M13 5 l7 7 -7 7"/></I>
)
